import MomentalMarketing from "./Marketing";

export default MomentalMarketing;
